import { useLayoutEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type TabEntry = {
	value: number;
	path: string;
};

type Args = {
	parentPath: string;
	storageKey: string;
	tabs: TabEntry[];
};

export const useResolveTabFromStorage = ({
	parentPath,
	storageKey,
	tabs,
}: Args) => {
	const navigate = useNavigate();
	const { pathname } = useLocation();

	const isResolving = pathname === parentPath;

	useLayoutEffect(() => {
		if (!isResolving) return;
		const stored = Number(localStorage.getItem(storageKey));
		const target =
			tabs.find((tab) => tab.value === stored)?.path ?? tabs[0].path;
		navigate(target, { replace: true });
	}, [isResolving, navigate, storageKey, tabs]);

	return isResolving;
};
